import get from "lodash/get";
import includes from "lodash/includes";

import { MAINTENANCE_MODE } from "../constants";

/**
 * Ensure user exists.
 */
function maintenanceMode({ req, res, load, locals }, next) {
  // continue if we are not in maintenance mode
  if (!MAINTENANCE_MODE.enabled) return next();

  // continue at login/logout and maintenance mode as these should always be available
  if (includes(["/login", "/logout", "/maintenance"], req.path)) return next();

  // get the logged in user
  const user = get(locals, "activeUser");

  // if a user is not logged in, goto maintenance
  if (!user) return res.redirect("/maintenance");

  // if at the root and logged in, goto the maintenance
  if (!user && req.path === "/") return res.redirect("/maintenance");

  if (
    // admins should have access
    get(user, "admin", false) ||
    // all accounts with tillerdigital emails should have access
    user.email.includes("@tillerdigital.ca") ||
    // all users in the allowed accounts array should have access
    includes(MAINTENANCE_MODE.allowedAccounts, user.email)
  ) {
    return next();
  }

  // if we haven't continued yet, the user should only see the maintenance page
  return res.redirect("/maintenance");
}

export default maintenanceMode;
